export default __webpack_public_path__ + "static/media/bank.6062d41e.svg";